import React, {useEffect} from 'react';

import {useDispatch} from 'react-redux';

import {useHostSelector} from 'hooks/hostHooks/hostHooks';

import {CartConnected} from './cart';
import {RootQueryFlowDataProvider} from './components/rootQueryFlowWrapper/rootQueryFlowWrapper';

import {setDataFromHostStore} from './store/actions';

import s from './index.scss';

const BlankComponentForSettingHostData = () => {
    const dispatch = useDispatch();
    const hostData = useHostSelector(state => state.cart);

    useEffect(() => {
        dispatch(setDataFromHostStore(hostData));
    }, []);

    return null;
};

/**
 * Default class for Cart page
 * @return {React.DOM} React rendered component
 */
const Cart = () => {
    return (
        <div className={s.responsiveCart}>
            <RootQueryFlowDataProvider>
                {({checkOrderData}) => (
                    <>
                        <BlankComponentForSettingHostData />
                        <CartConnected isCheckOrderRequestDone={checkOrderData.isCheckOrderDone} />
                    </>
                )}
            </RootQueryFlowDataProvider>
        </div>
    );
};

export default Cart;
